import { Alert, Stack, Typography } from "@mui/material";
import { usePortraitsTranslator } from "../i18n/translator";
import { useGetMe } from "../useGetMe";
import { PortraitFlow } from "./PortraitFlow";

export const OwnPortraitPage = () => {
  const translator = usePortraitsTranslator();
  const { data: me } = useGetMe();

  return (
    <PortraitFlow
      name={me?.name}
      generateOnArrival
      renderHeading={(subtitle) => (
        <Stack spacing={1} alignItems="center" textAlign="center">
          <Typography variant="h4" component="h1">
            {translator("pageTitle")}
          </Typography>
          <Typography color="text.secondary">{subtitle}</Typography>
        </Stack>
      )}
      renderFlag={({ flagged }) =>
        flagged && (
          <Alert severity="warning">{translator("yourPortraitFlagged")}</Alert>
        )
      }
    />
  );
};
